import { curryN, filter, isEmpty, contains } from 'ramda'

export const compact = filter(Boolean)

export const isPresent = (value: any): boolean => {
  if (value === null || value === undefined) {
    return false
  } else {
    return !isEmpty(value)
  }
}

export const result = curryN(
  2,
  (path: string, obj: { [prop: string]: any }): Object | undefined => {
    if (!obj) {
      return undefined
    }

    path.split('.').some((segment) => {
      obj = obj[segment]
      return !obj
    })

    return obj
  }
)

export const maybeContains = curryN(2, function <T>(k: T, xs: Array<T>): boolean {
  if (xs) {
    return contains(k, xs)
  } else {
    return false
  }
})
